// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Shell-module_shell_Olap0lUPZTYLB_Ulh8fQ{display:flex;align-items:center;justify-content:center;flex:1 1 auto}", "",{"version":3,"sources":["webpack://./src/components/shell/Shell.module.scss"],"names":[],"mappings":"AACA,yCACE,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,aAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~cx-web-themes/crunchyroll/abstracts/main\";\n.shell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": "Shell-module_shell_Olap0lUPZTYLB_Ulh8fQ"
};
export default ___CSS_LOADER_EXPORT___;
